export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type: 'Secao',
              name: "Seção Cabeçalho",
              attributes: { class: 'section-header shadow'  },
              components: [
                {
                  type: 'containerHeader2',
                },
      
              ],
              styles: `
             .section-header{
               position:relative; 
               with:100vw; 
               padding: 20px 5%; 
             }
               .shadow{
              box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
            }
             *{
              font-family: Roboto, Arial, sans-serif;
            }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};